/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { EquipmentTemplateService } from './EquipmentTemplateService';

class EquipmentTemplateServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new EquipmentTemplateService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { EquipmentTemplateServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/equipment/service/EquipmentTemplateServiceProvider.js